import WorkflowStepValidation from "./workflowStepValidation";
import FormStep from "../../../formability/form_builder/models/workflow/formStep";
import WorkflowStepLinkedDocumentValidator from "../navigableValidators/workflowStepLinkedDocumentValidator";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";

export default class FormStepValidation extends WorkflowStepValidation<FormStep> {
  validators = new WorkflowStepValidation(this.model).validators.concat([
    new WorkflowStepLinkedDocumentValidator({
      validatorKey: "dependent_form",
      section: ValidationModalSection.Workflow
    })
  ]);
}